<template>
  <users-list></users-list>
</template>

<script>
import UsersList from "../../../components/Settings/Users/UsersList";
export default {
  name: "SettingsUsersView",
  components: { UsersList }
};
</script>

<style scoped></style>
